<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { getDeskPhoneIdInLink } from '@/flows/helper/vendor-product';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { planTypes } from '@/common/constants';

export default {
  name: 'DeskPhoneAddon',
  mixins: [base, planCommon],
  for: (args) => {
    const [, , , , , allPlanMap] = args;
    const hasValidVendorProduct = !!allPlanMap?.__vendorsData?.products?.length
    const enableHardware4Online = window.campaignFlags?.enableHardware4Online

    const dpId = getDeskPhoneIdInLink()
    const isBuyNowAndBasic2ProFlow = [flowTypes.buyNow, flowTypes.basic2pro].includes(pageConfig.type)
    const isUSCABuyNowFlow = isBuyNowAndBasic2ProFlow && pageConfig.plan === planTypes.ZOOM_PHONE && pageConfig.editConfig.category.startsWith('pbx_ZV')
    const isBizPlusBuyNowFlow = isBuyNowAndBasic2ProFlow && pageConfig.plan === planTypes.ZOOM_ONE_BUNDLE
    const isProPlusBuyNowFlow = isBuyNowAndBasic2ProFlow && pageConfig.plan === planTypes.ZONE_PRO_PLUS

    return hasValidVendorProduct && enableHardware4Online && (
      !!dpId || isUSCABuyNowFlow || isBizPlusBuyNowFlow || isProPlusBuyNowFlow
    );
  },
  data() {
    return {
      addText: 'View Phones'
    }
  },
  mounted() {
    this.handleCustomDeskPhone()
  },
  methods: {
    handleCustomDeskPhone() {
      this.$nextTick(() => {
        const dpId = getDeskPhoneIdInLink()
        if (dpId === 'custom') {
          this.addOn()
        }
      })
    },
    async addOn() {
      await this.mx_openDeskPhoneDialog()
      this.$emit('add', this.$options?.key)
    }
  }
};
</script>
